import { createContext, useContext } from "react";
import type { KeyboardEvent as ReactKeyboardEvent } from "react";

export type HeaderSearchTarget =
  | { type: "search"; search: user_prefs.RecentSearch }
  | { type: "person"; person: user_prefs.RecentlyViewedPerson }
  | { type: "viewed"; item: user_prefs.RecentlyViewedItem };

export type HeaderSearchRecentsApi = {
  loading: boolean;
  recentSearches: readonly user_prefs.RecentSearch[];
  recentlyViewedPeople: readonly user_prefs.RecentlyViewedPerson[];
  recentlyViewed: readonly user_prefs.RecentlyViewedItem[];
  clearSearches: () => void;
  resetHighlight: () => void;
  rememberSearch: (item: user_prefs.RecentSearch) => void;
  rememberPerson: (person: user_prefs.RecentlyViewedPerson) => void;
  rememberOpenedPerson: (
    person: user_prefs.RecentlyViewedPerson,
    search: user_prefs.RecentSearch
  ) => void;
  rememberViewed: (item: user_prefs.RecentlyViewedItem) => void;
  rememberOpenedView: (
    item: user_prefs.RecentlyViewedItem,
    search: user_prefs.RecentSearch
  ) => void;
  targets: readonly HeaderSearchTarget[];
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  activeOptionId: string | undefined;
  onInputKeyDown: (event: ReactKeyboardEvent | KeyboardEvent) => boolean;
  openTarget: (
    target: HeaderSearchTarget,
    destination?: "profile" | "allocations"
  ) => void;
};

export const HeaderSearchRecentsContext =
  createContext<HeaderSearchRecentsApi | null>(null);

export const useHeaderSearchRecentsContext = () =>
  useContext(HeaderSearchRecentsContext);

export const headerSearchOptionId = (index: number) =>
  `header-search-option-${index}`;
